import { IBusinessPriority } from '../model/types'

export const isBusinessPriorityActiveInMarket = (
  record: IBusinessPriority,
  market: string
): boolean => (market ? record.markets.includes(market) : false)
